import { useProgress, Center, Text3D } from "@react-three/drei"
import { useThree } from "@react-three/fiber";



export default function Timerloader() {
    const { loaded, total } = useProgress()
    const status = (loaded / total) * 100
    const { width, height } = useThree((state) => state.viewport)
    return <Center
        rotation={[-0.2, 0, 0]}
        position={[0.05, -1, 0]}
    >
        <Text3D size={0.2} font="./fonts/Inter_Bold.json">
            {status.toFixed(0)} %
            <meshBasicMaterial color="#F41F4E" />
        </Text3D>
    </Center>
}